import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "RSS not dead, just misunderstood",
  "description": "",
  "published": "2010-09-14T00:00:00.000Z",
  "redirect_from": ["/blog/rss-not-dead-just-misunderstood/swizec/1454"],
  "categories": "Dave Winer, Facebook, Feed Readers, Online Communities, RSS, Social network, Technology, Twitter, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://www.crunchbase.com/company/twitter"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2010/09/54559v1-max-250x250.png",
              "alt": "Image representing Twitter as depicted in Crun...",
              "title": "Image representing Twitter as depicted in Crun..."
            }}></img></a></p>
        <p parentName="li">{`Image via `}<a parentName="p" {...{
            "href": "http://www.crunchbase.com"
          }}>{`CrunchBase`}</a></p>
      </li>
    </ul>
    <p>{`Lately there has been raging debate in the blogosphere (is that still a word?) around whether `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/RSS",
        "title": "RSS"
      }}>{`RSS`}</a>{` is dead or not and the fact that it's apparently been dying ever since it was first conceived in 1999 or thereabouts.`}</p>
    <p>{`Arguments range all the way from the fact that it is useless in light of `}<a parentName="p" {...{
        "href": "http://twitter.com",
        "title": "Twitter"
      }}>{`Twitter`}</a>{` and `}<a parentName="p" {...{
        "href": "http://facebook.com",
        "title": "Facebook"
      }}>{`Facebook`}</a>{`, that it never managed to jump the gap, that people simply can't use it and that it all looks like RSS readers are being shut off left and right. Signs of great decay left and right, let's abandon the poor thing completely and let it die in peace right?`}</p>
    <p>{`But there is one very very important thing that everybody is missing: RSS is not a user-facing technology. Just like the `}<a parentName="p" {...{
        "href": "http://semanticweb.org",
        "title": "Semantic Web"
      }}>{`semantic web`}</a>{`, it was never meant to be something people actually `}<em parentName="p">{`use`}</em>{`.`}</p>
    <p>{`RSS is essentially one big hack, a pretty good way of having content delivered to you without specifically going out there and looking for it. Even though, essentially, that's exactly what your RSS reader does. It's got a list of websites it checks every so often and then gets back to you with the results. In that regard it's essentially a bunch of bookmarks, you're just not tending to them yourself. It's just a bit easier for a computer to read xml than a website. With pubsubhubbub the way this is done has changed a little, but no biggie.`}</p>
    <p>{`Ok, so RSS is a content distribution technology for computers.`}</p>
    <p>{`Now, we all know that as technologies go, there needs to be that one killer feature that trumps all alternatives right?`}</p>
    <p>{`Well twitter's got one, the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Communications_protocol",
        "title": "Communications protocol"
      }}>{`communication protocol`}</a>{` is dead simple, simpler than phones. Great!`}</p>
    <p>{`And facebook's got one too, they're a bit of everything, not very simple, but everyone's got a facebook so you're not leaving any time soon because you're locked. Great!`}</p>
    <p>{`What does RSS have?`}</p>
    <p>{`Well, it's got geeks. Lots and lots and lots of hardcore geeks. Did you know geeks produce the most content on `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Social_network",
        "title": "Social network"
      }}>{`social networks`}</a>{`? How do you think stuff gets on your twitter and your facebook? Somebody's got to post it there before it can go viral. That someone likely found out via RSS. Sure this can be automated, but then you've just ruined the most important part of consuming content via twitter or facebook - the social filtering.`}</p>
    <p>{`But there's an even more important feature to RSS.`}</p>
    <p><strong parentName="p">{`Infinite scalability. Infinite distributability.`}</strong></p>
    <p>{`Both twitter and facebook are tied to a single provider. Twitter's servers go down and all you see is a failwhale. No content for you. Imagine, for example, a huge earthquake hits california. Now suddenly both twitter's and facebook's `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Data_center",
        "title": "Data center"
      }}>{`data centers`}</a>{` are offline. No content.`}</p>
    <p>{`But RSS would bravely go on working perfectly. Some sites might not be able to update, but the rest of the world wouldn't even notice a glitch. Everything just works smoothly.`}</p>
    <p>{`Basically I guess what I'm saying is the same as `}<a parentName="p" {...{
        "href": "http://scripting.com/stories/2010/09/13/howToRebootRss.html"
      }}>{`Dave Winer`}</a>{`. RSS is here to stay, `}<a parentName="p" {...{
        "href": "http://lazyreadr.com/"
      }}>{`somebody`}</a>{` just needs to step up to the plate and make an RSS reader for `}<em parentName="p">{`people.`}</em></p>
    <h6 {...{
      "id": "related-articles-by-zemanta"
    }}>{`Related articles by Zemanta`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://gigaom.com/2010/09/13/no-rss-is-not-dead-and-neither-are-rss-readers/"
        }}>{`No, RSS Is Not Dead, and Neither Are RSS Readers`}</a>{` (gigaom.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://scobleizer.com/2010/09/13/reboot-rss-readers-sorry-that-train-has-left-the-station/"
        }}>{`Loic Le Meur, CEO of Seesmic, and I were arguing last week about whether RSS has a future or not. He speaks up for "it has a future" on his blog. Dave Winer today...`}</a>{` (scobleizer.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://blog.twingly.com/2010/09/14/rss-wont-die-but-news-readers-are-evolving-and-becoming-more-social/"
        }}>{`RSS won't die, but news readers are evolving and becoming more social`}</a>{` (twingly.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.plagiarismtoday.com/2010/09/13/the-changing-face-of-rss/"
        }}>{`The Changing Face of RSS - What the Death of Bloglines Means for the Future of RSS`}</a>{` (plagiarismtoday.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=fd148594-8cfe-4036-aca0-4e36d387ae45",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      